













import Vue from 'vue'
import { Device } from '@/types/device'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'

import TableDevice from './Table.vue'
import DeviceConfig from './Config.vue'

export default Vue.extend({
  name: 'DeviceManager',
  components: { Splitpanes, Pane, TableDevice, DeviceConfig },
  data() {
    return {
      selected: {} as Device,
    }
  },
  methods: {
    selectedChanged(selected: Device) {
      this.selected = selected
    },
  },
})
